import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=84b082ba&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84b082ba')) {
      api.createRecord('84b082ba', component.options)
    } else {
      api.reload('84b082ba', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=84b082ba&", function () {
      api.rerender('84b082ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22A76H66ogMlr/JS/comp/ImgFallback.vue"
export default component.exports